/**
 * @file 获取各角色人员列表
 */
import {get} from '@/utils/decorate/request';
import {Url} from '@/utils/api.js';
import toast from '@/utils/decorate/toast';

export default {
    // 获取官方流程跟进人
    getOfficialFollowerList() {
        let url = Url.officialSupporterListUrl;
        return get(url).catch(errmsg => toast.error(errmsg));
    },
    // 获取官方流程审核人员
    getOfficialAuthorList() {
        let url = Url.officialAuthorListUrl;
        return get(url).catch(errmsg => toast.error(errmsg));
    }
};
